import { useCallback, useState } from 'react';
export function usePasswordToggle(type) {
    const isPassword = type === 'password';
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = useCallback(()=>{
        setShowPassword((prev)=>!prev);
    }, []);
    return {
        isPassword,
        inputType: isPassword && showPassword ? 'text' : type,
        showPassword,
        togglePassword
    };
}
export function useInputValue(type) {
    return useCallback((evt)=>{
        const { value, checked } = evt.target;
        if ((type === 'checkbox' || type === 'radio') && !checked) {
            return '';
        }
        if (type === 'number' && value !== '') {
            return Number(value);
        }
        return value;
    }, [
        type
    ]);
}
